.spectrum--light .spectrum-CircleLoader-track {
  border-color: rgb(225, 225, 225);
}
.spectrum--light .spectrum-CircleLoader-fill {
  border-color: rgb(20, 115, 230);
}
.spectrum--light .spectrum-CircleLoader--overBackground .spectrum-CircleLoader-track {
    border-color: rgba(255,255,255,0.2);
  }
.spectrum--light .spectrum-CircleLoader--overBackground .spectrum-CircleLoader-fill {
    border-color: rgb(255, 255, 255);
  }
.spectrum--light .spectrum-CircleLoader--indeterminate.spectrum-CircleLoader--overBackground .spectrum-CircleLoader-track {
    border-color: rgba(255,255,255,0.2);
  }
.spectrum--light .spectrum-CircleLoader--indeterminate.spectrum-CircleLoader--overBackground .spectrum-CircleLoader-fill {
    border-color: rgb(255, 255, 255);
  }
